import { FC, useEffect } from 'react';
import { CareMapFlow } from './CareMapFlow';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from './CareMapState';
import { isPlatform } from '@ionic/react';
import { CareMapDrawerState } from './CareMapDrawerState';
import { useSubscription } from '@meraki-internal/state';
import { InnerhivePage } from '../InnerhivePage';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

export const CareMapPage: FC = () => {
    const careMapStateInstance = useInstance(CareMapState);
    useSubscription(() => careMapStateInstance);
    const drawerState = useInstance(CareMapDrawerState);
    useSubscription(() => drawerState);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const isDrawerOpen = drawerState.isOpen();

    useEffect(() => {
        mixpanel.track('Care Map Page Opened');
    }, [mixpanel]);

    return (
        <InnerhivePage skipAddingIonContent skipAddingNavigation showCareMapConfig>
            <CareMapFlow
                name="full"
                blur={isDrawerOpen}
                fit={isDrawerOpen ? 'none' : 'custom'}
                includeControls={isPlatform('desktop')}
                careMap={careMapStateInstance.getActiveCaremap()!}
            />
        </InnerhivePage>
    );
};
